import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag is available and is a function
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
          page_title: document.title, // Add page title for better tracking
          page_location: window.location.href // Add full URL
        });
      } catch (error) {
        // Silently handle any gtag errors to prevent app crashes
        console.error('Google Analytics tracking error:', error);
      }
    }
  }, [location]);
};